import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { NgxsModule } from "@ngxs/store";
import { SharedConfirmationModule } from "@vp/shared/confirmation";
import { TagManagerState } from "@vp/tag-manager/data-access/tag-manager-state";
import { TagMenuSelectorComponent } from "./tag-menu-selector.component";

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    SharedConfirmationModule,
    NgxsModule.forFeature([TagManagerState])
  ],
  declarations: [TagMenuSelectorComponent],
  exports: [TagMenuSelectorComponent]
})
export class TagMenuSelectorModule {}
